export function runNumber(index: number, page: number, limit: number): number {
  if (page > 1) return index + ((page - 1) * limit + 1)
  return index + 1
}
